import React from 'react';
import { Box, Typography } from '@mui/material';

export function Banner({ children = 'Prochaine release: 17 avril 2026 – Isa Men' }) {
  return (
    <Box
      component="section"
      sx={{
        py: 1.25,
        px: 2,
        bgcolor: 'primary.main',
        color: 'tertiary.main',
        textAlign: 'center',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <Typography variant="overline" component="span" sx={{ fontWeight: 600, letterSpacing: '0.12em' }}>
        {children}
      </Typography>
    </Box>
  );
}

export default Banner;
